import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import '../Dashboard/matchup.css';
import { Alert, Row, Col } from 'react-bootstrap';
import PlayerPanel from '../Dashboard/playerPanel';
import UserHeader from '../UserHeader';
import TeamLegend from '../Dashboard/teamLegend';
import Logo from '../../global/img/logo_full.png';
import { highlightColumn, highlightColumnColor, checkHealthScoreStatus, getPlayerCategories, sortPlayersByGamingScore } from '../utils/dashboardCalculations';
import './style.css';
import { sortArrayOfObj } from '../utils/utils';
// import InputFields from "../InputFields/index";

// Helper to format money line with + for positive numbers
function formatMoneyLine(value) {
	if (typeof value === 'number') {
		return value > 0 ? `+${value}` : `${value}`;
	}
	if (typeof value === 'string' && value !== '') {
		const num = Number(value);
		if (!isNaN(num)) {
			return num > 0 ? `+${num}` : `${num}`;
		}
		return value;
	}
	return value;
}

function NFLMatchup(props) {
	let { id: gameID } = useParams();
	useEffect(() => {
		window.scrollTo(0, 0);
		let { dispatch, match, healthScores, assignCurrentSport } = props;
		assignCurrentSport();
		if (!match.match || gameID) {
			dispatch({ type: 'GET_MATCH', payload: { gameID } });
			if (!healthScores.categoryAverages) {
				dispatch({ type: 'GET_HEALTH_SCORES', payload: { gameID } });
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [showAwayRoster, handleShowAwayRoster] = useState(false);
	const [showHomeRoster, handleShowHomeRoster] = useState(false);

	const toggleRosterView = (type) => {
		if (type === 'away') {
			handleShowAwayRoster(!showAwayRoster);
		} else if (type === 'home') {
			handleShowHomeRoster(!showHomeRoster);
		}
	};

	const { match, schedules, user, hideUserHeader, toggleScheduleView, healthScores, teams } = props;
	const title = 'Health Scores for Team Matchups';

	if (match.isLoading || healthScores.isLoading || user.isLoading)
		return (
			<div id='fullHeight'>
				<div id='loading' />
			</div>
		);
	if (!match.awayPlayers || !match.homePlayers) {
		return (
			<React.Fragment>
				<div className='gameMainDiv'>
					<div className="sticky-header">
						<UserHeader matchup={true} backgroundColor={'#f7f7f7'} title={title} />
					</div>
					<h1
						className='bold text-center'
						dangerouslySetInnerHTML={{ __html: match.error }}
					/>
				</div>
			</React.Fragment>
		);
	}
	const game = match?.match[0];
	let { awayPlayers, homePlayers } = match;

	const awayTeam = teams?.data?.teamInfo?.find((x) => x.team_id === game?.away_team_id);
	const homeTeam = teams?.data?.teamInfo?.find((x) => x.team_id === game?.home_team_id);

	const {
		away_team_city,
		away_team_name,
		home_team_city,
		home_team_name,
		over_under_prediction_outcome,
		away_team_logo,
		home_team_logo,
		over_under,
		point_spread,
		disable_over_under_bet,
		disable_spread_bet,
		// date_time,
		point_spread_away_team_money_line,
		point_spread_home_team_money_line,
		away_team_money_line,
		home_team_money_line
		// away_team_score,
		// home_team_score,
		// status,
		// over_under_prediction_correct,
		// spread_prediction_correct,
	} = game;
	console.log(game, 'game')
	// {point_spread < 0 ? point_spread : `-${point_spread}`}
	let favoredTeamBySpread, awayTeamPointSpread, homeTeamPointSpread;
	let pointSpreadLogo;
	if (point_spread >= 0) {
		awayTeamPointSpread = `-${point_spread}`;
		homeTeamPointSpread = `+${point_spread}`;
	} else {
		awayTeamPointSpread = `+${Math.abs(point_spread)}`;
		homeTeamPointSpread = point_spread;
	}

	if (game?.favored_team_by_predicted_spread?.split(':')[0]?.toUpperCase() === 'AWAY') {
		pointSpreadLogo = <img src={away_team_logo} alt='Team Logo' className='matchupPointSpreadLogo' />;
		favoredTeamBySpread = `${away_team_city} ${away_team_name}`;
	} else if (game?.favored_team_by_predicted_spread?.split(':')[0]?.toUpperCase() === 'HOME') {
		pointSpreadLogo = <img src={home_team_logo} alt='Team Logo' className='matchupPointSpreadLogo' />;
		favoredTeamBySpread = `${home_team_city} ${home_team_name}`;
	} else {
		favoredTeamBySpread = "Unpredictable.";
	}
	console.log(pointSpreadLogo, 'pointSpreadLogo', favoredTeamBySpread, 'favoredTeamBySpread')

	const overUnderPrediction = over_under_prediction_outcome?.toUpperCase() === 'UNPREDICTABLE' ? "Unpredictable." : over_under_prediction_outcome;
	console.log(disable_over_under_bet, 'disable_over_under_bet.....')

	const offensiveSkillsAway = awayPlayers && getPlayerCategories(awayPlayers, 'offensiveskills', healthScores, awayTeam);
	const offensiveLineAway = awayPlayers && getPlayerCategories(awayPlayers, 'offensiveline', healthScores, awayTeam);
	const defensiveLineAway = awayPlayers && getPlayerCategories(awayPlayers, 'defensiveline', healthScores, awayTeam);
	const defensiveSecondaryAway = awayPlayers && getPlayerCategories(awayPlayers, 'defensivesecondary', healthScores, awayTeam);
	const offensiveSkillsHome = homePlayers && getPlayerCategories(homePlayers, 'offensiveskills', healthScores, homeTeam);
	const offensiveLineHome = homePlayers && getPlayerCategories(homePlayers, 'offensiveline', healthScores, homeTeam);
	const defensiveLineHome = homePlayers && getPlayerCategories(homePlayers, 'defensiveline', healthScores, homeTeam);
	const defensiveSecondaryHome = homePlayers && getPlayerCategories(homePlayers, 'defensivesecondary', healthScores, homeTeam);

	let topFourAway = awayPlayers && sortPlayersByGamingScore(awayPlayers);
	let topFourHome = homePlayers && sortPlayersByGamingScore(homePlayers);

	// const awayRoster = awayPlayers;
	// const homeRoster = homePlayers;
	// Parse roster players from API (homeRosterPlayers, awayRosterPlayers)
	const awayRosterPlayersResp = match?.awayRosterPlayers || [];
	const homeRosterPlayersResp = match?.homeRosterPlayers || [];

	// Helper to parse roster JSON and pick the correct team by full name
	const parseTeamRoster = (rows, teamFullName) => {
		if (!rows || !rows.length) return null;
		// Try to find a response JSON in any row
		const jsonStr = (rows.find(r => r && r.response && typeof r.response === 'string') || {})?.response;
		if (false && jsonStr) {
			try {
				const data = JSON.parse(jsonStr);
				const teams = Array.isArray(data?.teams) ? data.teams : [];
				const stripDiacritics = (s) => (s || '').normalize('NFD').replace(/\p{Diacritic}+/gu, '');
				const normBasic = (s) => (s || '').toString().trim().toLowerCase();
				const normalized = (s) => {
					const t = stripDiacritics(s).toLowerCase();
					return t.replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
				};
				const target = normalized(teamFullName);
				const teamObj =
					teams.find(t => normalized(t?.team_name) === target) ||
					teams.find(t => normalized(`${t?.team_name}`)?.includes(normalized(game?.away_team_name)) || normalized(`${t?.team_name}`)?.includes(normalized(game?.home_team_name))) ||
					teams[0];
					if (teamObj) {
						// Build an index from SQL rows to enrich JSON players with IDs and details
					const nameKey = (obj) => normalized(obj?.full_name || obj?.player_name || obj?.nickname || obj?.name);
					const altKeys = (r) => {
						const keys = new Set();
						[key => key].forEach(() => {}); // no-op to satisfy lints for unused helpers
						[ r.full_name, r.player_name, r.nickname ].forEach(n => { if (n) keys.add(nameKey({ full_name: n })); });
						return Array.from(keys);
					};
					const rowIndex = new Map();
					(rows || []).forEach(r => {
						altKeys(r).forEach(k => { if (k && !rowIndex.has(k)) rowIndex.set(k, r); });
					});
						const enrich = (arr) => (arr || []).map(p => {
							const key = nameKey(p);
							let rowMatch = rowIndex.get(key);
						if (!rowMatch && p?.full_name) {
							// try a looser match: remove middle parts or compare startsWith
							const parts = normalized(p.full_name).split(' ');
							if (parts.length > 1) {
								const tryKey = `${parts[0]} ${parts[parts.length - 1]}`;
								rowMatch = rowIndex.get(tryKey) || rowIndex.get(parts[0]) || rowIndex.get(parts[parts.length - 1]);
							}
						}
							return {
								...p,
								full_name: p.full_name || p.player_name || rowMatch?.full_name || rowMatch?.player_name || p.name,
								player_id: p.player_id || rowMatch?.player_id,
								// Always prefer DB row fields for position and gaming_score
								position: rowMatch?.position || rowMatch?.position_map || rowMatch?.position_category || p.position,
								gaming_score: rowMatch?.gaming_score ?? p.gaming_score,
							};
						});
					return {
						team_name: teamObj.team_name,
						projected_starters: enrich(teamObj.projected_starters),
						active_roster: enrich(teamObj.active_roster),
						inactive_or_injured: enrich(teamObj.inactive_or_injured)
					};
				}
			} catch (e) {
				// fall back to building from rows
			}
		}
		// Build bundles directly from SQL rows (roaster_players): use player_name, player_id, position, gaming_score
		const toPlayer = (r) => ({
			player_id: r.player_id,
			role: r.role || (r.depth_chart_order === 1 ? 'Starter' : 'Bench'),
			position: r.position,
			gaming_score: r.gaming_score,
			full_name: r.player_name
		});
		const starters = rows.filter(r => (r.role && String(r.role).toLowerCase() === 'starter') || r.depth_chart_order === 1).map(toPlayer);
		const inactive = rows.filter(r => {
			const s = (r.status || r.injury_status || '').toString().toLowerCase();
			return s && s !== 'active';
		}).map(toPlayer);
		const active = rows.filter(r => {
			const s = (r.status || r.injury_status || '').toString().toLowerCase();
			return !s || s === 'active';
		}).map(toPlayer);
		if (!starters.length && !active.length && !inactive.length) return null;
		return {
			team_name: teamFullName,
			projected_starters: starters,
			active_roster: active,
			inactive_or_injured: inactive
		};
	};
	const awayTeamFullName = [game?.away_team_city, game?.away_team_name].filter(Boolean).join(' ');
	const homeTeamFullName = [game?.home_team_city, game?.home_team_name].filter(Boolean).join(' ');
	const awayRosterBundle = parseTeamRoster(awayRosterPlayersResp, awayTeamFullName);
	const homeRosterBundle = parseTeamRoster(homeRosterPlayersResp, homeTeamFullName);
	
	const awayRoster =
		awayPlayers &&
		awayPlayers.filter((x) => {
			if (x.active === 1) {
				return x;
			}
			return;
		});
	const homeRoster =
		homePlayers &&
		homePlayers.filter((x) => {
			if (x.active === 1) {
				return x;
			}
			return;
		});

	awayRoster.sort(sortArrayOfObj('player_name', 'asc'));
	homeRoster.sort(sortArrayOfObj('player_name', 'asc'));

	const homeHealthScore = game && game.home_team_gaming_score;
	const awayHealthScore = game && game.away_team_gaming_score;
	const homeStatusText = checkHealthScoreStatus(homeHealthScore, false, 'team');
	const awayStatusText = checkHealthScoreStatus(awayHealthScore, false, 'team');
	let teamHighlightShadowAway;
	let teamHighlightShadowHome;
	const highlightCol = highlightColumn(homeHealthScore, awayHealthScore);
	if (highlightCol === 'away') {
		teamHighlightShadowAway = 'teamShadowHighlight';
	} else if (highlightCol === 'home') {
		teamHighlightShadowHome = 'teamShadowHighlight';
	}
	const homeHighlightColor = highlightColumnColor(homeHealthScore, 'teamHighlight');
	const awayHighlightColor = highlightColumnColor(awayHealthScore, 'teamHighlight');
	console.log(homeHighlightColor, 'homeHighlightColor',)
	const offenseDesc = 'This category reflects the avg health score of all core offensive players injuries on a specific team. It assesses their injury impact on performance as a group.';
	const defenseDesc = "This category reflects the avg health score of all core defensive players' injuries on a specific team. It assesses their injury impact on performance as a group.";
	const offenseDefenseDesc = "This category reflects the avg health score of all core players' injuries on a specific team. It assesses their injury impact on performance as a group.";

	// Define position groups for offense and defense
	const offensePositions = ['QB', 'RB', 'WR', 'TE', 'FB'];
	const defensePositions = ['DE', 'CB', 'SS', 'FS', 'S', 'LB', 'OLB', 'MLB'];

	const top4OffenseAway = sortPlayersByGamingScore(
		awayPlayers.filter(p => offensePositions.includes(p.position))
	).slice(0, 4);
	const top4DefenseAway = sortPlayersByGamingScore(
		awayPlayers.filter(p => defensePositions.includes(p.position))
	).slice(0, 4);
	const top4OffenseHome = sortPlayersByGamingScore(
		homePlayers.filter(p => offensePositions.includes(p.position))
	).slice(0, 4);
	const top4DefenseHome = sortPlayersByGamingScore(
		homePlayers.filter(p => defensePositions.includes(p.position))
	).slice(0, 4);

	return (
		<section className='gameMainSection'>
			<div className='gameMainDiv'>
				<div className="sticky-header">
					<UserHeader matchup={true} backgroundColor={'#f7f7f7'} title={title} hideUserHeader={hideUserHeader} toggleScheduleView={() => toggleScheduleView()} game={game} />
				</div>
				<div className='gameBoxShadow'>
					<Row className='gameSpreadHeaderRow'>
						<Col lg={6} className={`gameSpreadHeaderCol ${awayHighlightColor}`}>
							<div className='gameSpreadHeaderDiv'>
								<React.Fragment>
									<p className='gameSpreadHeaderSpread'>
										<span style={{ paddingRight: '20px' }}>{awayStatusText.status}</span>
										{awayHealthScore}
									</p>
									<p className='gameSpreadHeaderDescription'>Team Health Score</p>
								</React.Fragment>
							</div>
						</Col>
						<Col lg={6} className={`gameSpreadHeaderCol ${homeHighlightColor}`}>
							<div className='gameSpreadHeaderDiv'>
								<React.Fragment>
									<p className='gameSpreadHeaderDescription'>Team Health Score</p>
									<p className='gameSpreadHeaderSpread pull-right'>
										<span style={{ paddingRight: '20px' }}>{homeStatusText.status}</span>
										{homeHealthScore}
									</p>
								</React.Fragment>
							</div>
						</Col>
					</Row>
					<Row className='gameTeamHeaderRow'>
						<Col lg={6} className={`gameTeamHeaderCol ${teamHighlightShadowAway} col-xs-12`}>
							<div className='gameTeamHeaderDiv'>
								<p className={`gameTeamHeaderSpread bold ${awayHighlightColor}`}>{awayHealthScore}</p>
								<div className='gameTeamHeaderLogoDiv gameTeamHeaderLogoAwayDiv'>
									<img src={game.away_team_logo} alt='Team Logo' className='gameTeamLogo' />
									<p className='gameTeamHeaderName gameTeamHeaderNameAway'>{game.away_team_city + ' ' + game.away_team_name}</p>
								</div>
							</div>
						</Col>
						<Col lg={6} className={`gameTeamHeaderCol ${teamHighlightShadowHome} col-xs-12`}>
							<div className='gameTeamHeaderDiv gameTeamHeaderDivHome'>
								<div className='gameTeamHeaderLogoDiv gameTeamHeaderLogoRightDiv'>
									<p className='gameTeamHeaderName gameTeamHeaderNameHome'>@ {game.home_team_city + ' ' + game.home_team_name}</p>
									<img src={game.home_team_logo} alt='Team Logo' className='gameTeamLogo' />
								</div>
								<p className={`gameTeamHeaderSpread gameTeamHeaderSpreadRight bold ${homeHighlightColor}`}>{homeHealthScore}</p>
							</div>
						</Col>
					</Row>
					<Row className='bettingRow'>
						<Col lg={12} className='bettingCol colAlignContentCenter'>
							<h2>SPREAD/MONEYLINE</h2>
						</Col>
						<Col lg={12} className='bettingCol'>							
							<div className='bettingInfoDiv'>
								<p className='bettingInfo bettingInfoLeft'>
									<label className="playerInfoProgressLabel">Spread/Moneyline</label><br />
									<span className='bettingInfoTeamName'>
										{game.away_team_city + ' ' + game.away_team_name}
										<br />
									</span>
									<span>{awayTeamPointSpread}</span>
									<br />
									<span>{formatMoneyLine(point_spread_away_team_money_line)}</span>
								</p>

								<p className='bettingInfo bettingInfoRight'>
									<label className="playerInfoProgressLabel">Spread/Moneyline</label><br />
									<span className='bettingInfoTeamName'>
										{game.home_team_city + ' ' + game.home_team_name}
										<br />
									</span>
									<span>{homeTeamPointSpread}</span>
									<br />
									<span>{formatMoneyLine(point_spread_home_team_money_line)}</span>
								</p>
							</div>
						</Col>
						<Col lg={12} className='bettingCol'>							
							<div className='bettingInfoDiv'>
								<p className='bettingInfo bettingInfoLeft'>
									<label className="playerInfoProgressLabel">Moneyline</label>
									<span className='bettingInfoTeamName'>
										{game.away_team_city + ' ' + game.away_team_name}
										<br />
									</span>									
									<br />
									<span>{formatMoneyLine(away_team_money_line)}</span>
								</p>

								<p className='bettingInfo bettingInfoRight'>
									<label className="playerInfoProgressLabel">Moneyline</label>
									<span className='bettingInfoTeamName'>
										{game.home_team_city + ' ' + game.home_team_name}
										<br />
									</span>									
									<br />
									<span>{formatMoneyLine(home_team_money_line)}</span>
								</p>
							</div>
						</Col>
					</Row>
					<hr className='matchupInfoHrSeparator' />
					<Row className='bettingRow'>
						<Col lg={12} className='colAlignContentCenter'>
							<h2>OVER/UNDER: {over_under}</h2>
						</Col>
					</Row>
					<hr className='matchupInfoHrSeparator' />
					<Row className='bettingRow bettingPredictionRow'>
						<Col lg={12} className='bettingCol colAlignContentCenter'>
							<div className='expertPicksHeaderDiv'>
								<img src={Logo} alt='Inside Injuries Logo' className='matchupLogo' />
								<h2 className='brandColor expertPicksHeader'>EXPERT PICKS</h2>
							</div>
						</Col>
						<Col lg={12} className='bettingCol'>
							<div className='bettingPredictionDiv'>
								<p className='bettingPredictionInfo bettingInfoLeft'>
									<span>OVER/UNDER PREDICTION</span>
									<br />
									{/* <span className='brandColor'>{disable_over_under_bet ? "Unpredictable." : overUnderPrediction}</span> */}
									<span className='brandColor'>{disable_over_under_bet || !overUnderPrediction ? "Unpredictable." : overUnderPrediction}</span>
								</p>
								<p className='bettingPredictionInfo bettingInfoRight'>
									<span>FAVORED TEAM BY SPREAD</span>
									<br />
									<span className='brandColor'>
										{disable_spread_bet ? (
											"Unpredictable."
										) : (
											<>
												{pointSpreadLogo} {favoredTeamBySpread}
											</>
										)}
									</span>

								</p>
							</div>
						</Col>
					</Row>
					{game.game_description && (
						<Row className='gameDescriptionRow'>
							<Col lg={12} className='gameDescriptionCol'>
								<p className='gameDescription'>{game.game_description}</p>
							</Col>
						</Row>
					)}
					<TeamLegend />
					{user?.login && (
						<>
							<div className='topFourPlayerDiv'>
								<h1 className='dashboardHowItWorksHeader'>Top 4 Offensive Players</h1>
							</div>
							<Row>
								<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol1'>
									<div className='matchupHeaderDiv'>
										<hr className='hrStyleMobile' />
										<div className="team-header-with-logo">
											<img src={game.away_team_logo} alt="Away Team Logo" className="team-logo-inline" />
											<span>{game.away_team_city} {game.away_team_name}</span>
										</div>
										<hr className='hrStyleMobile' />
										<Row>
											{top4OffenseAway.filter(Boolean).map((players, i) => (
												<Col lg={6} key={i}>
													<Link
														className='routerLinkMatchup hover-delay'
														title={`${players.player_name}`}
														to={{
															pathname: `/nfl/player/${players?.player_id}`,
															playerID: players?.player_id
														}}
													>
														<div className='matchPlayerDiv'>
															<div className='matchPlayerInfoDiv matchPlayerInfoTopDiv'>
																<p className='matchPlayerInfoNameTop' style={{ textDecoration: 'underline' }}>{players.nickname || players.player_name}</p>
																<p className='matchPlayerInfoInjury'>
																	<span className='grey'>POSITION:</span>
																	<span className='matchPlayerInfo'>{players.position}</span>
																</p>
																<p className='matchPlayerInfoInjury'>
																	<span className='grey'>HEALTH SCORE:</span>
																	<span className='matchPlayerInfo'>{players.gaming_score || '10'}</span>
																</p>
															</div>
														</div>
													</Link>
												</Col>
											))}
										</Row>
									</div>
								</Col>
								<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol1'>
									<div className='matchupHeaderDiv'>
										<hr className='hrStyleMobile' />
										<div className="team-header-with-logo">
											<img src={game.home_team_logo} alt="Home Team Logo" className="team-logo-inline" />
											<span>{game.home_team_city} {game.home_team_name}</span>
										</div>
										<hr className='hrStyleMobile' />
										<Row>
											{top4OffenseHome.filter(Boolean).map((players, i) => (
												<Col lg={6} key={i}>
													<Link
														className='routerLinkMatchup hover-delay'
														title={`${players.player_name}`}
														to={{
															pathname: `/nfl/player/${players?.player_id}`,
															playerID: players?.player_id
														}}
													>
														<div className='matchPlayerDiv'>
															<div className='matchPlayerInfoDiv matchPlayerInfoTopDiv'>
																<p className='matchPlayerInfoNameTop' style={{ textDecoration: 'underline' }}>{players.nickname || players.player_name}</p>
																<p className='matchPlayerInfoInjury'>
																	<span className='grey'>POSITION:</span>
																	<span className='matchPlayerInfo'>{players.position}</span>
																</p>
																<p className='matchPlayerInfoInjury'>
																	<span className='grey'>HEALTH SCORE:</span>
																	<span className='matchPlayerInfo'>{players.gaming_score || '10'}</span>
																</p>
															</div>
														</div>
													</Link>
												</Col>
											))}
										</Row>
									</div>
								</Col>
							</Row>
							<div className='topFourPlayerDiv'>
								<h1 className='dashboardHowItWorksHeader'>Top 4 Defensive Players</h1>
							</div>
							<Row>
								<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol1'>
									<div className='matchupHeaderDiv'>
										<hr className='hrStyleMobile' />
										<div className="team-header-with-logo">
											<img src={game.away_team_logo} alt="Away Team Logo" className="team-logo-inline" />
											<span>{game.away_team_city} {game.away_team_name}</span>
										</div>
										<hr className='hrStyleMobile' />
										<Row>
											{top4DefenseAway.filter(Boolean).map((players, i) => (
												<Col lg={6} key={i}>
													<Link
														className='routerLinkMatchup hover-delay'
														title={`${players.player_name}`}
														to={{
															pathname: `/nfl/player/${players?.player_id}`,
															playerID: players?.player_id
														}}
													>
														<div className='matchPlayerDiv'>
															<div className='matchPlayerInfoDiv matchPlayerInfoTopDiv'>
																<p className='matchPlayerInfoNameTop' style={{ textDecoration: 'underline' }}>{players.nickname || players.player_name}</p>
																<p className='matchPlayerInfoInjury'>
																	<span className='grey'>POSITION:</span>
																	<span className='matchPlayerInfo'>{players.position}</span>
																</p>
																<p className='matchPlayerInfoInjury'>
																	<span className='grey'>HEALTH SCORE:</span>
																	<span className='matchPlayerInfo'>{players.gaming_score || '10'}</span>
																</p>
															</div>
														</div>
													</Link>
												</Col>
											))}
										</Row>
									</div>
								</Col>
								<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol1'>
									<div className='matchupHeaderDiv'>
										<hr className='hrStyleMobile' />
										<div className="team-header-with-logo">
											<img src={game.home_team_logo} alt="Home Team Logo" className="team-logo-inline" />
											<span>{game.home_team_city} {game.home_team_name}</span>
										</div>
										<hr className='hrStyleMobile' />
										<Row>
											{top4DefenseHome.filter(Boolean).map((players, i) => (
												<Col lg={6} key={i}>
													<Link
														className='routerLinkMatchup hover-delay'
														title={`${players.player_name}`}
														to={{
															pathname: `/nfl/player/${players?.player_id}`,
															playerID: players?.player_id
														}}
													>
														<div className='matchPlayerDiv'>
															<div className='matchPlayerInfoDiv matchPlayerInfoTopDiv'>
																<p className='matchPlayerInfoNameTop' style={{ textDecoration: 'underline' }}>{players.nickname || players.player_name}</p>
																<p className='matchPlayerInfoInjury'>
																	<span className='grey'>POSITION:</span>
																	<span className='matchPlayerInfo'>{players.position}</span>
																</p>
																<p className='matchPlayerInfoInjury'>
																	<span className='grey'>HEALTH SCORE:</span>
																	<span className='matchPlayerInfo'>{players.gaming_score || '10'}</span>
																</p>
															</div>
														</div>
													</Link>
												</Col>
											))}
										</Row>
									</div>
								</Col>
							</Row>
						</>
					)}
					{(awayRosterBundle || homeRosterBundle) ? (
						<>
							<Row>
								<Col lg={12}>
									<h1 className='dashboardHowItWorksHeader'>Roster Players</h1>
								</Col>
							</Row>
							<Row className='gameMatchupRow'>
								{/* Away Roster */}
								<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol1'>
									<div className='matchupHeaderDiv'>
										<hr className='hrStyleMobile' />
										<div className="team-header-with-logo">
											<img src={game.away_team_logo} alt="Away Team Logo" className="team-logo-inline" />
											<span>{game.away_team_city} {game.away_team_name}</span>
										</div>
										<hr className='hrStyleMobile' />
										<Row>
											<Col lg={12} className='matchupHeaderCol'>
												<hr className='hrStyleMobile' />
												<p className='matchupMobileHeader'>{[game.away_team_city, game.away_team_name].filter(v => v && v !== 'null').join(' ')}</p>
												<hr className='hrStyleMobile' />
											</Col>
										</Row>
									</div>
									<div style={{ paddingBottom: '30px' }}>
										{awayRosterBundle?.active_roster?.length ? (
											<div style={{ marginBottom: '16px' }}>
												<Row>
													{awayRosterBundle.active_roster.map((p, idx) => (
														<Col lg={6} key={`away-act-${idx}`}>
															<div className='matchPlayerDiv'>
																<div className='matchPlayerInfoDiv matchPlayerInfoTopDiv'>
																	<Link
																		className='routerLinkMatchup hover-delay'
																		title={`${p.full_name}`}
																		to={p?.player_id ? `/nba/player/${p.player_id}` : '#'}
																	>
																		<p className='matchPlayerInfoNameTop'>{p.full_name}</p>
																		<p className='matchPlayerInfoInjury'>
																			<span className='grey'>POSITION:</span>
																			<span className='matchPlayerInfo'>{p.position}</span>
																		</p>
																		<p className='matchPlayerInfoInjury'>
																			<span className='grey'>HEALTH SCORE:</span>
																			<span className='matchPlayerInfo'>{p.gaming_score || '10'}</span>
																		</p>
																	</Link>
																</div>
															</div>
														</Col>
													))}
												</Row>
											</div>
										) : null}
									</div>
								</Col>
								{/* Home Roster */}
								<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol2'>
									<div className='matchupHeaderDiv'>
										<hr className='hrStyleMobile' />
										<div className="team-header-with-logo">
											<img src={game.home_team_logo} alt="Home Team Logo" className="team-logo-inline" />
											<span>{game.home_team_city} {game.home_team_name}</span>
										</div>
										<hr className='hrStyleMobile' />
										<Row>
											<Col lg={12} className='matchupHeaderCol'>
												<hr className='hrStyleMobile' />
												<p className='matchupMobileHeader'>{[game.home_team_city, game.home_team_name].filter(v => v && v !== 'null').join(' ')}</p>
												<hr className='hrStyleMobile' />
											</Col>
										</Row>
									</div>
									<div style={{ paddingBottom: '30px' }}>
										{homeRosterBundle?.active_roster?.length ? (
										<div style={{ marginBottom: '16px' }}>                                                
											<Row>
												{homeRosterBundle.active_roster.map((p, idx) => (
													<Col lg={6} key={`home-act-${idx}`}>
														<div className='matchPlayerDiv'>
															<div className='matchPlayerInfoDiv matchPlayerInfoTopDiv'>
																<Link
																	className='routerLinkMatchup hover-delay'
																	title={`${p.full_name}`}
																	to={p?.player_id ? `/nba/player/${p.player_id}` : '#'}
																>
																	<p className='matchPlayerInfoNameTop'>{p.full_name}</p>
																
																	<p className='matchPlayerInfoInjury'>
																		<span className='grey'>POSITION:</span>
																		<span className='matchPlayerInfo'>{p.position}</span>
																	</p>
																	<p className='matchPlayerInfoInjury'>
																		<span className='grey'>HEALTH SCORE:</span>
																		<span className='matchPlayerInfo'>{p.gaming_score || '10'}</span>
																	</p>
																</Link>	
															</div>
														</div>
													</Col>
												))}
											</Row>
										</div>
									) : null}
									</div>
								</Col>
							</Row>
						</>
					) : null}
					<Row className='gameMatchupRow'>
						{/* Away Team */}
						<Col lg={12}>
							<h1 className='dashboardHowItWorksHeader'>Position Categories</h1>
						</Col>
						<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol1'>
							<div className='matchupHeaderDiv'>
								<Row>
									<Col lg={8} className='matchupHeaderCol'>
										<hr className='hrStyleMobile' />
										<p className='matchupMobileHeader'>
											{/* {game.away_team_city} {game.away_team_name} */}
											{[game.away_team_city, game.away_team_name].filter(v => v && v !== 'null').join(' ')}
										</p>
										<hr className='hrStyleMobile' />
										<a href='#/' className='matchupViewAll hover-delay' onClick={() => toggleRosterView('away')}>
											{!showAwayRoster ? 'VIEW AWAY TEAM ROSTER' : 'VIEW POSITION CATEGORIES'}
										</a>
									</Col>
									<Col lg={3} className='matchupHeaderCol'>
										<p className='matchupHeader'>Health Score</p>
									</Col>
									<Col lg={1} />
								</Row>
							</div>
							{!showAwayRoster ? (
								<React.Fragment>
									<div style={{ paddingBottom: '40px' }}>
										<PlayerPanel id={4} healthScoreStatus={offensiveLineAway} players={offensiveLineAway.players} panelTitle='OFFENSIVE LINE' tooltip={offenseDesc} sportsName='nfl' teamLogo={game.away_team_logo} />
										<PlayerPanel id={5} healthScoreStatus={offensiveSkillsAway} players={offensiveSkillsAway.players} panelTitle='OFFENSIVE SKILLS PLAYERS' tooltip={offenseDesc} sportsName='nfl' teamLogo={game.away_team_logo} />
										<PlayerPanel id={6} healthScoreStatus={defensiveLineAway} players={defensiveLineAway.players} panelTitle='DEFENSIVE LINE' tooltip={defenseDesc} sportsName='nfl' teamLogo={game.away_team_logo} />
										<PlayerPanel id={7} healthScoreStatus={defensiveSecondaryAway} players={defensiveSecondaryAway.players} panelTitle='DEFENSIVE SECONDARY' tooltip={defenseDesc} sportsName='nfl' teamLogo={game.away_team_logo} />
									</div>
								</React.Fragment>
							) : (
								<React.Fragment>
									<PlayerPanel id={1} healthScoreStatus={checkHealthScoreStatus(game.away_team_gaming_score, awayRoster, 'team')} players={awayRoster} panelTitle='ALL ACTIVE PLAYERS' tooltip={offenseDefenseDesc} openAll={showAwayRoster} toggleRosterView={() => toggleRosterView('away')} sportsName='nfl' teamLogo={game.away_team_logo} />
								</React.Fragment>
							)}
						</Col>

						{/* Home Team */}

						<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol2'>
							<div className='matchupHeaderDiv'>
								<Row>
									<Col lg={8} className='matchupHeaderCol'>
										<hr className='hrStyleMobile' />
										<p className='matchupMobileHeader'>
											{/* {game.home_team_city} {game.home_team_name} */}
											{[game.home_team_city, game.home_team_name].filter(v => v && v !== 'null').join(' ')}
										</p>
										<hr className='hrStyleMobile' />
										<a href='#/' className='matchupViewAll hover-delay' onClick={() => toggleRosterView('home')}>
											{!showHomeRoster ? 'VIEW HOME TEAM ROSTER' : 'VIEW POSITION CATEGORIES'}
										</a>
									</Col>
									<Col lg={3} className='matchupHeaderCol'>
										<p className='matchupHeader'>Health Score</p>
									</Col>
									<Col lg={1} />
								</Row>
							</div>
							{!showHomeRoster ? (
								<React.Fragment>
									<div style={{ paddingBottom: '30px' }}>
										<PlayerPanel id={4} healthScoreStatus={offensiveLineHome} players={offensiveLineHome.players} panelTitle='OFFENSIVE LINE' tooltip={offenseDesc} sportsName='nfl' teamLogo={game.home_team_logo} />
										<PlayerPanel id={5} healthScoreStatus={offensiveSkillsHome} players={offensiveSkillsHome.players} panelTitle='OFFENSIVE SKILLS PLAYERS' tooltip={offenseDesc} sportsName='nfl' teamLogo={game.home_team_logo} />
										<PlayerPanel id={6} healthScoreStatus={defensiveLineHome} players={defensiveLineHome.players} panelTitle='DEFENSIVE LINE' tooltip={defenseDesc} sportsName='nfl' teamLogo={game.home_team_logo} />
										<PlayerPanel id={7} healthScoreStatus={defensiveSecondaryHome} players={defensiveSecondaryHome.players} panelTitle='DEFENSIVE SECONDARY' tooltip={defenseDesc} sportsName='nfl' teamLogo={game.home_team_logo} />
									</div>
								</React.Fragment>
							) : (
								<React.Fragment>
									<PlayerPanel id={8} healthScoreStatus={checkHealthScoreStatus(game.home_team_gaming_score, homeRoster, 'team')} players={homeRoster} panelTitle='ALL ACTIVE PLAYERS' tooltip={offenseDefenseDesc} openAll={showHomeRoster} toggleRosterView={() => toggleRosterView('home')} sportsName='nfl' teamLogo={game.home_team_logo} />
								</React.Fragment>
							)}
						</Col>
					</Row>
				</div>
			</div>
		</section>
	);
}

const mapStateToProps = (state) => ({
	isLoading: state.isLoading,
	isLoaded: state.isLoaded,
	healthScores: state.healthScores,
	match: state.match,
	schedules: state.schedules,
	teams: state.teams,
	user: state.user
});

export default connect(mapStateToProps)(NFLMatchup);